@let disabled = disabled$ | async;
<app-control-wrapper
  [control]="control"
  [officeField]="officeField"
  [formGroupInstance]="formGroupInstance"
  [errorsMessagesOverridesRegistry]="errorsMessagesOverridesRegistry"
  [required]="control | controlHasRequired"
  [validating]="validating$()"
  [disabled]="disabled || validating$()"
  [touched]="isTouched$ | async"
  [dirty]="isDirty$ | async"
  [alignment]="alignment"
  [config]="config">
  <quill-editor
    class="app-rich-text"
    [modules]="modules"
    [formControl]="control"
    [ngClass]="{ invalidInput: invalid$ | async, 'app-rich-text__disabled': disabled || validating$() }"
    [readOnly]="disabled || validating$()"
    format="html"
    [sanitize]="true"></quill-editor>
</app-control-wrapper>
